import { useEffect, useState } from 'react'
import type GoogleOnTap from 'google-one-tap'
import { otlLogin } from '@mote/api'
import { useScript } from '@mote/helpers'
import { GOOGLE_CLIENT_ID } from '@mote/helpers/constants'
import { useAuth } from './useAuth'
import { useLoginSuccess } from './useLoginSuccess'

export function useOTL(isDisabled?: boolean): string {
  const auth = useAuth()
  const loginSuccess = useLoginSuccess()
  const [refreshKey, setRefreshKey] = useState<string>(
    auth.user?.accessToken ?? ''
  )
  const scriptStatus = useScript(
    isDisabled ? '' : 'https://accounts.google.com/gsi/client'
  )

  function successCallback(
    credentials: GoogleOnTap.CredentialResponse
  ): Promise<void> {
    return otlLogin({
      ...credentials,
      containingURL: window.location.href
    }).then(everything => loginSuccess(everything, true))
  }

  useEffect(() => {
    setRefreshKey(auth.user?.accessToken ?? '')
  }, [auth.user?.accessToken])

  useEffect(() => {
    let parent = document.getElementById('g_id_onload')

    if (
      isDisabled ||
      !GOOGLE_CLIENT_ID ||
      auth.isAuthenticated ||
      scriptStatus !== 'ready' ||
      (scriptStatus === 'ready' && !('google' in window))
    ) {
      if (parent) {
        parent.remove()
      }
      return
    }

    if (!parent) {
      parent = document.createElement('div')
      parent.setAttribute('id', 'g_id_onload')
      Object.assign(parent.style, {
        position: 'fixed',
        top: '16px',
        right: '16px',
        zIndex: 9999
      })
      document.body.appendChild(parent)
    }

    google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: successCallback,
      cancel_on_tap_outside: false,
      ux_mode: 'popup',
      prompt_parent_id: 'g_id_onload',
      itp_support: true
    })
    google.accounts.id.prompt()
  }, [auth.isAuthenticated, scriptStatus, isDisabled])

  return refreshKey
}
